import { Deserializable } from './deserializable';
import { ROLE_NAMES } from '../constants';
import { BaseModel } from './base.model';

export class RoleModel extends BaseModel implements Deserializable {

  // columns
  id: number;
  name: string;
  title: any;
  priority: number;
  editable: boolean;
  rights: Array<string>;
  data_scopes: Array<number>; // tslint:disable-line: variable-name

  get rolename(): string {
    return ROLE_NAMES[this.name] || this.title['DE'] || this.name;
  }

  get translated_rolename(): string {
    if (this.transloco) {
      return this.transloco.translate(this.rolename);
    }
    return this.rolename;
  }

  get translated_title(): string {
    const lang = this.transloco.getActiveLang();
    return (this.title !== null) ? this.title[lang.toUpperCase()] : this.name;
  }

}
